module.exports = __webpack_public_path__ + "static/media/small-logo-risk.c76ec28f.svg";